import { render } from "./Actions.vue?vue&type=template&id=c2e7e07e&scoped=true"
import script from "./Actions.vue?vue&type=script&lang=js"
export * from "./Actions.vue?vue&type=script&lang=js"

import "./Actions.vue?vue&type=style&index=0&id=c2e7e07e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c2e7e07e"

export default script